// ============================================================================
// GST SOURCE SETUP SERVICE (ADR-0025 Revision 1, R1.4)
// ============================================================================
// A client's sample files, read and compared once before monthly work: what
// each provides, what is missing, where files overlap and whether they agree,
// and which to build each part of the return from. Samples never feed a return.

import { get, post, del } from '../client/axiosClient';
import { gstEndpoints } from '../endpoints/gst.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type {
  FinaliseGstSourceSetupRequest,
  GstExpectedFile,
  GstSampleFile,
  GstSourceAnalysis,
} from '../types/gstEngagement.types';

class GstSourceSetupService {
  async listSamples(engagementId: string): Promise<GstSampleFile[]> {
    const response = await get<any>(gstEndpoints.engagementSetupSamples(engagementId));
    return (response.data?.data ?? []) as GstSampleFile[];
  }

  /** Drops a sample's parses so it can be parsed again, or left out of the analysis. */
  async discardParses(engagementId: string, documentId: string): Promise<void> {
    await del<any>(gstEndpoints.engagementSetupSampleParses(engagementId, documentId));
  }

  /** Coverage, missing fields, overlaps and agreement for one GSTIN. Writes nothing. */
  async analyse(engagementId: string, registrationId: string): Promise<GstSourceAnalysis> {
    const response = await get<any>(buildEndpointWithQuery(gstEndpoints.engagementSetupAnalysisBasePath(engagementId), { registrationId }));
    return response.data?.data as GstSourceAnalysis;
  }

  async finalise(engagementId: string, request: FinaliseGstSourceSetupRequest): Promise<{ files: GstExpectedFile[]; notes: string[]; message: string }> {
    const response = await post<any>(gstEndpoints.engagementSetupFinalise(engagementId), request);
    const data = response.data?.data ?? {};
    return { files: data.files ?? [], notes: data.notes ?? [], message: response.data?.message ?? 'Saved.' };
  }
}

export const gstSourceSetupService = new GstSourceSetupService();
export default gstSourceSetupService;
